<template>
  <div class="validation_request_representative" v-if="representative">
    <div>
        <h5>{{getEnumTranslatedValue('customer_person_type', representative.attributes.customer_person_type)}} ({{ statusComplement }})</h5>
        <p>Qualité : {{getEnumTranslatedValue('representative_quality', representative.attributes.representative_quality)}}</p>
        <p v-if="representative.attributes.moral_person">Personne morale : {{representative.attributes.corporation_name}}</p>
        <p>Nom : {{getEnumTranslatedValue('civility', representative.attributes.civility)}} {{representative.attributes.first_name}} {{representative.attributes.last_name}}</p>
        <p v-if="representative.attributes.mobile_phone">Tél. Mobile: {{representative.attributes.mobile_phone}}</p>
        <p v-if="representative.attributes.phone">Tél. Fixe: {{representative.attributes.phone}}</p>
        <p v-if="representative.attributes.email">
          Email: <a :href="'mailto:' + representative.attributes.email">{{representative.attributes.email}}</a>
        </p>
    </div>
    <div v-if="representative.attributes.representative_end_date" class="termination-date">
      Date de démission : {{representative.attributes.representative_end_date | moment-date}}
    </div>
  </div>
</template>

<script>
export default {
  name:"VrRepresentative",
  props:["representative", "current"],
  computed: {
    statusComplement() {
      if (this.representative.attributes.representative_main) {
        return this.current ? 'principal actuel' : 'principal'
      }

      return 'secondaire'
    }
  }
}
</script>

<style scoped>
.validation_request_representative {
    padding: 0 15px;
    border: solid 1px lightgray;
    background-color: white;
}

.validation_request_representative h5 { border-bottom: 1px solid lightgray; padding-bottom: 5px; }

.validation_request_representative .termination-date { font-weight: bold; margin-bottom: 10px; }
</style>



// WEBPACK FOOTER //
// client/components/Demands/Details/ValidationRequestable/RepresentativeV2.vue